import { bus } from "@/main.js";
import { getLocalAccessToken } from "@/utils/tokenService.js";

export default {
  wbConnection: null,
  wbNotificationConnection: null,
  connection() {
    return new Promise((resolve, reject) => {
      if (this.wbConnection) {
        resolve(this.wbConnection);
      } else {
        const token = getLocalAccessToken();
        this.wbConnection = new WebSocket(
          `${process.env.VUE_APP_SOCKET_URL}/ws/chat/?token=${token}`
        );
        this.wbConnection.onopen = () => {
          resolve(this.wbConnection);
        };
        this.wbConnection.onmessage = (event) => {
          let wb = JSON.parse(event.data);
          if (
            (wb && wb.type == "chat_history") ||
            wb.type == "new_message" ||
            wb.type == "new_message_received"
          ) {
            bus.$emit("getChatData", wb);
          } else if (wb.type == "user_notification_received") {
            bus.$emit("getNotification", wb.data);
          }
        };
        this.wbConnection.onerror = function (err) {
          reject(err);
        };
      }
    });
  },
  notificationConnection() {
    return new Promise((resolve, reject) => {
      if (this.wbNotificationConnection) {
        resolve(this.wbNotificationConnection);
      } else {
        const token = getLocalAccessToken();
        this.wbNotificationConnection = new WebSocket(
          `${process.env.VUE_APP_SOCKET_URL}/ws/user_notification/?token=${token}`
        );
        this.wbNotificationConnection.onopen = () => {
          resolve(this.wbNotificationConnection);
        };
        this.wbNotificationConnection.onmessage = (event) => {
          let wb = JSON.parse(event.data);
          bus.$emit("getNotification", wb.data);
        };
        this.wbNotificationConnection.onerror = function (err) {
          reject(err);
        };
      }
    });
  },
  notificationCloseConnection() {
    return new Promise((resolve, reject) => {
      if (this.wbNotificationConnection) {
        this.wbNotificationConnection.close();
        console.log("Connection close...");
        this.wbNotificationConnection = null;
        resolve("Connection close...");
      } else {
        reject(this.wbNotificationConnection);
      }
    });
  },
  closeConnection() {
    return new Promise((resolve, reject) => {
      if (this.wbConnection) {
        this.wbConnection.close();
        console.log("Connection close...");
        this.wbConnection = null;
        resolve("Connection close...");
      } else {
        reject(this.wbConnection);
      }
    });
  },
};
